import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/site';
import { ContactForm } from './ContactForm';
export function Faqs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faqs" className="bg-paper py-24" data-id="element-97" data-mp="30dbuwi5vlql5">
      <div className="mx-auto grid max-w-[1240px] gap-16 px-6 lg:grid-cols-[1.1fr_0.9fr]" data-id="element-98" data-mp="356ep8sih942e">
        <div data-id="element-99" data-mp="3a5rdnhozyj73">
          <p className="eyebrow text-green-dark" data-id="element-100" data-mp="3a46ipqyrsy8p">FAQs</p>
          <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-101" data-mp="3f4cdhg0c70v0">
            Questions we are asked before an engagement.
          </h2>
          <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-102" data-mp="3o50sacxk158y" />

          <ul className="mt-10 border-t border-line" data-id="element-103" data-mp="3o2wqc0j7ugbb">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <li key={faq.question} className="border-b border-line" data-id="element-104" data-mp="1ts1620yo5csp" data-mpi={i}>
                  <h3 data-id="element-105" data-mp="2hc0mxw569vt4">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-106" data-mp="2hck43an00g63">
                      <span className="text-[16px] font-medium text-ink" data-id="element-107" data-mp="30acxnmbqfdqt">
                        {faq.question}
                      </span>
                      <span className={`font-mono text-[18px] leading-none text-green-dark transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-108" data-mp="2vcbez2i7xgfv">
                        +
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-109" data-mp="19wvzgezyschm">
                    {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-110" data-mp="1y8bjiuzz210">
                        <p className="pb-6 pr-10 text-[15px] leading-relaxed text-ink-70" data-id="element-111" data-mp="3ef3jvtgx1na0">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>

        <ContactForm data-id="element-112" data-mp="3ac774je24ldz" />
      </div>
    </section>;
}